import { render, staticRenderFns } from "./LoginAsBanner.vue?vue&type=template&id=5721ee8a&scoped=true"
import script from "./LoginAsBanner.vue?vue&type=script&lang=js"
export * from "./LoginAsBanner.vue?vue&type=script&lang=js"
import style0 from "./LoginAsBanner.vue?vue&type=style&index=0&id=5721ee8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721ee8a",
  null
  
)

export default component.exports